/* Sea Moss Hydration — flavor-specific gallery filter.
 * Runs only on /products/sea-moss-hydration. Hides gallery images whose alt text
 * does not contain the currently selected flavor name. */
(function () {
  'use strict';

  function run() {
    // Only on the Sea Moss Hydration PDP
    if (!/\/products\/sea-moss-hydration(?:\?|\/|$)/.test(window.location.pathname + window.location.search)) return;

    function currentFlavor() {
      // Try to read the selected variant's option (Flavor) from the form
      var input = document.querySelector('select[name="options[Flavor]"], input[name="options[Flavor]"]:checked');
      if (input && input.value) return input.value;
      var urlVariant = new URLSearchParams(location.search).get('variant');
      if (urlVariant) {
        var opt = document.querySelector('option[value="' + urlVariant + '"], input[value="' + urlVariant + '"]');
        if (opt && opt.dataset && opt.dataset.optionValue) return opt.dataset.optionValue;
        if (opt && opt.textContent) return opt.textContent.trim();
      }
      // Fallback: look for radio-style variant picker (most Dawn-based themes)
      var selectedRadio = document.querySelector('fieldset[name*="Flavor" i] input[checked], fieldset input[type="radio"][name*="Flavor" i]:checked');
      if (selectedRadio && selectedRadio.value) return selectedRadio.value;
      return null;
    }

    function matchesFlavor(alt, flavor) {
      if (!flavor) return true;
      alt = (alt || '').toLowerCase();
      flavor = flavor.toLowerCase();
      if (flavor.indexOf('morning') !== -1 || flavor.indexOf('guava') !== -1) return alt.indexOf('morning glow') !== -1;
      if (flavor.indexOf('prime') !== -1 || flavor.indexOf('lemon') !== -1) return alt.indexOf('prime time') !== -1;
      return true;
    }

    function filter() {
      var flavor = currentFlavor();
      if (!flavor) return;

      // Gallery image containers (Dawn/theme conventions)
      var selectors = [
        '.product__media-list > li',           // Dawn list items
        '.product__media-item',                 // alternate naming
        'media-gallery li',                     // media-gallery custom element
        '.product-single__media',               // older Dawn
        '.thumbnail-list > li',                 // thumbnail strip
        '.product__thumbs-item'                 // alternate thumb naming
      ];

      selectors.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (item) {
          var img = item.querySelector('img');
          if (!img) return;
          var alt = img.getAttribute('alt') || '';
          if (matchesFlavor(alt, flavor)) {
            item.style.display = '';
            item.removeAttribute('hidden');
          } else {
            item.style.display = 'none';
            item.setAttribute('hidden', '');
          }
        });
      });

      // If the currently-featured main image doesn't match, click the first matching thumbnail
      var mainImg = document.querySelector('.product__modal-opener img, .product__media.product__media--featured img, [data-media-type="image"].is-active img');
      if (mainImg && !matchesFlavor(mainImg.getAttribute('alt') || '', flavor)) {
        var firstMatch = null;
        document.querySelectorAll('.product__media-list > li:not([hidden]) img, media-gallery li:not([hidden]) img, .thumbnail-list > li:not([hidden]) img').forEach(function (im) {
          if (!firstMatch && matchesFlavor(im.getAttribute('alt') || '', flavor)) firstMatch = im;
        });
        if (firstMatch) {
          var thumbBtn = firstMatch.closest('a, button, [data-media-id]');
          if (thumbBtn) thumbBtn.click();
        }
      }
    }

    // Initial filter on load
    filter();

    // Re-run on any variant change
    document.addEventListener('change', function (e) {
      if (e.target && (e.target.name || '').toLowerCase().indexOf('flavor') !== -1) {
        setTimeout(filter, 120);
      }
      if (e.target && (e.target.name === 'id' || e.target.name === 'options[]' || (e.target.name || '').startsWith('options['))) {
        setTimeout(filter, 120);
      }
    });

    // Listen for Shopify's theme-published variant change events
    ['variant:change', 'variant-change', 'on:variant:change'].forEach(function (evt) {
      document.addEventListener(evt, function () { setTimeout(filter, 120); });
    });

    // MutationObserver fallback: watch for variant picker updates
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'attributes' && (m.attributeName === 'selected' || m.attributeName === 'checked')) {
          setTimeout(filter, 120);
          break;
        }
      }
    });
    document.querySelectorAll('variant-selects, variant-radios, form[action*="/cart/add"]').forEach(function (el) {
      mo.observe(el, { attributes: true, childList: true, subtree: true });
    });

    // Re-run on popstate (variant URL updates)
    window.addEventListener('popstate', function () { setTimeout(filter, 120); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
